(function() {
	'use strict';

	angular.module('widgets.buyer')

	.config(buyerStdMyPrsToFirmConfig);
	function buyerStdMyPrsToFirmConfig(dashboardProvider) {
		var buyerStdMyPrsToFirm = {
			name: 'PRs to Firm',
			description: 'Number of PRs inside lead time grouped by age plus number of PRs inside procurement lead time.',
			thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/my_current_shortages.png',
			categories: ['All', 'Shortages'],
			config: {},
			slideshowView: true,
			isActive: true,
			templateUrl: '/application/f/dashboard/widgets/buyer-standard-workload/my-prs-to-firm.template.html',
			isDrillDown: true,
			drillDownUrl: '#/supply-chain/purchase-requisitions/',
			reload: true,
			useFactoryFilter: true,
			controller: 'buyerStdMyPrsToFirmCtrl'
		};
		dashboardProvider.widget('buyerStdMyPrsToFirm', buyerStdMyPrsToFirm);
	}
})();
